import { Storage } from '@aws-amplify/storage';

const unsafeLetters = {
  // this relates to the AWS documentation
  // https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-keys.html
  '+': '%2B',
  ' ': '+',
};

export const refreshS3Path = url => {
  if (!url) {
    return undefined;
  }
  const tmp = url.split('/');

  const correctFilename = decodeURIComponent(tmp.pop());
  const sanitizedFilename = Object.entries(unsafeLetters).reduce(
    (acc, [currKey, currValue]) => {
      const regex = currKey;
      return acc.replaceAll(regex, currValue);
    },
    correctFilename
  );
  return `${tmp.join('/')}/${sanitizedFilename}`;
};

const handleUpload = async (path, file, fileId, fileName) => {
  const bucket = process.env.REACT_APP_WEB_S3_BUCKET_NAME;
  try {
    const res = await Storage.put(`${path}/${fileName}`, file, {
      bucket,
      // level: 'private',
      // Senza contentType esplicito la lib salva l'oggetto come
      // 'binary/octet-stream' (vedi commento su getSignedUrl sotto): per i
      // nuovi upload basta il mimeType del File del browser, niente
      // workaround sulla URL firmata necessario per questi.
      contentType: file.type || undefined,
    });

    return { name: fileName, s3Path: res.key, fileId: fileId };
  } catch (err) {
    console.error(err);
    return { name: '', s3Path: '' };
  }
};

const getS3ObjectUrl = key => {
  const innerKey = `public/${key}`;
  return `https://${process.env.REACT_APP_WEB_S3_BUCKET_NAME}.s3-${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${innerKey}`;
};

// Prima del fix a `contentType` in handleUpload sopra, ogni oggetto S3
// (documenti compresi) veniva salvato con Content-Type 'binary/octet-stream'
// di default (comportamento della lib quando contentType non è passato a
// Storage.put, vedi AWSS3Provider.put in @aws-amplify/storage) — un browser
// non può renderizzare inline un binary/octet-stream, forza sempre il
// download. `options` qui permette di sovrascrivere Content-Type/
// Content-Disposition SOLO sulla risposta della URL firmata (query S3
// standard `response-content-type`/`response-content-disposition`), senza
// toccare i metadata reali dell'oggetto: usato dalla preview PDF per forzare
// 'application/pdf' + 'inline' anche sui documenti caricati prima del fix.
const getSignedUrl = (key, options) => Storage.get(key, options);

const downloadFile = async key => {
  const signedURL = await getSignedUrl(key);
  window.open(signedURL);
};

const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'download';
  const clickHandler = () => {
    setTimeout(() => {
      URL.revokeObjectURL(url);
      a.removeEventListener('click', clickHandler);
    }, 150);
  };
  a.addEventListener('click', clickHandler, false);
  a.click();
  return a;
};

const downloadS3File = async (key, fileName) => {
  const defaultFileName = key.split('/').pop();
  const fileData = await Storage.get(key, { download: true });
  const temp = fileData.Body;
  downloadBlob(temp, fileName || defaultFileName);
};

const downloadExportFile = async key => {
  console.log(key, 'downloadExportFile key');
  const formatKey = key.replace('public/', '');
  console.log(formatKey, 'downloadExportFile formatKey');

  const signedURL = await Storage.get(formatKey);
  window.open(signedURL);
  //  window.open(key);
};

const deleteFromS3 = async key => Storage.remove(key);

export {
  handleUpload,
  deleteFromS3,
  getS3ObjectUrl,
  getSignedUrl,
  downloadFile,
  downloadBlob,
  downloadS3File,
  downloadExportFile,
};
